import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7eceb5b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "container hero-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Открой для себя мир прозрачного бизнеса", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Проверьте контрагента", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cn-banner",
  title: "Теперь доступен поиск по Китайской базе!"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "cn-banner__icon" }, "🐼"),
  /*#__PURE__*/_createElementVNode("div", { class: "cn-banner__text" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Теперь доступен поиск по Китайской базе!"),
    /*#__PURE__*/_createElementVNode("span", null, "Проверяйте компании из Китая прямо здесь")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Находите всю информацию по вашим контрагентам, добавляйте их в друзья, отслеживайте события", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_searchComponent = _resolveComponent("searchComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_searchComponent),
      _hoisted_6
    ])
  ]))
}